import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Auth } from "aws-amplify";
import { Page } from "@common-ui/ui";

import { Header } from "../../components";
import { CustomerProfile } from "./CustomerProfile";

import { getOrgCustomer } from "../../services/orgCustomer";
import { useSelector } from "react-redux";

export const Customer = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [customerDetails, setCustomerDetails] = useState({});
  let history = useHistory();
  let params = useParams();
  const currentOrganization = useSelector(
    (state) => state.organization.currentOrganization
  );
  let appRole = currentOrganization?.app_role;

  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  useEffect(() => {
    setIsSuccess(false);
    async function getCustomerDetails() {
      try {
        const details = await getOrgCustomer(params?.orgId, params?.id);
        setCustomerDetails(details);
      } catch (error) {
        console.log(error);
      }
    }
    getCustomerDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isSuccess) {
      async function getCustomerDetails() {
        try {
          const details = await getOrgCustomer(params?.orgId, params?.id);
          setCustomerDetails(details);
        } catch (error) {
          console.log(error);
        }
      }
      getCustomerDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <Page title="FlukeWorks">
      <>
        <Header xl name={`${customerDetails?.name ?? ""}`} history={history} />
        <CustomerProfile
          orgId={params?.orgId}
          isSuccess={isSuccess}
          setIsSuccess={setIsSuccess}
          customerDetails={customerDetails}
          addresses={customerDetails?.addresses}
          contacts={customerDetails?.contacts}
          appRole={appRole}
        />
      </>
    </Page>
  );
};
